<script setup>
// `transparent` drops the light-mode gradient band so the section sits
// directly on the page background (used on the about-us rework where the
// particle animation must stay visible). Other pages keep the default band.
const props = defineProps({
  transparent: { type: Boolean, default: false },
});

const projectImages = [
  {
    image: "/images/toolstation.webp",
    width: "188",
    height: "63",
  },
  {
    image: "/images/equetronic.webp",
    width: "170",
    height: "86",
  },
  {
    image: "/images/synergeyes.webp",
    width: "160",
    height: "83",
  },
  {
    image: "/images/jewesih.webp",
    width: "240",
    height: "71",
  },
  {
    image: "/images/jalapeno.webp",
    width: "190",
    height: "52",
  },
];
</script>
<template>
  <section
    class="relative mt-20 py-7 2xl:px-[140px] lg:px-20 px-4"
    :class="
      props.transparent
        ? ''
        : 'bg-[linear-gradient(90deg,_#29C9FF_-32.14%,_#1E539A_9.12%,_#6F13D5_97.4%)] dark:bg-none'
    "
  >
    <span
      class="hidden dark:block size-[1016px] rounded-full bg-[radial-gradient(circle,rgba(71,17,107,0.3)_0%,rgba(71,17,107,0.18)_45%,transparent_75%)] absolute top-0 left-[30%]"
    />
    <h2
      class="text-center text-4xl mb-9 relative z-10 tracking-[0.5px]"
      :class="
        props.transparent
          ? 'bg-brand-gradient bg-clip-text text-transparent'
          : 'text-white dark:text-[#E67AE2]'
      "
    >
      Some of Our Gems
    </h2>

    <div
      class="flex justify-center items-center xl:gap-[70px] max-xl:flex-wrap w-full gap-8 sm:gap-16 relative z-10 py-4 px-4 sm:px-12"
    >
      <template v-for="project in projectImages" :key="project.image">
        <NuxtImg
          alt="Project Images"
          :src="project.image"
          :width="project.width"
          :height="project.height"
          loading="lazy"
          class="relative z-10"
          format="webp"
        />
      </template>
    </div>
  </section>
</template>

<style scoped></style>
